/**
 * Toggle Accordion expanded panel.
 *
 * @param indexes Initial or current expanded accordion indexes
 * @param valueToAdd New expanded panel
 * @returns {number[]} ExpandedIndexes
 */
export const toggleAccordionExpand = (indexes: number[], valueToAdd: number): number[] => {
  const index = indexes.indexOf(valueToAdd);
  if (index > -1) {
    const copy = [...indexes];
    copy.splice(index, 1);
    return copy;
  } else {
    return [...indexes, valueToAdd];
  }
};
